import { useEffect } from 'react';
import { useAuth } from '~/apis/auth';
import { Logger } from '~/utils';

export const useSentryUserInfoUpdate = () => {
  const { data } = useAuth();

  useEffect(() => {
    if (data) {
      Logger.setUser(data.userId, data.email);
    }
  }, [data]);
};
